import { render, staticRenderFns } from "./RecurringPolicyView.vue?vue&type=template&id=704f30dc&"
import script from "./RecurringPolicyView.vue?vue&type=script&lang=js&"
export * from "./RecurringPolicyView.vue?vue&type=script&lang=js&"
import style0 from "./RecurringPolicyView.vue?vue&type=style&index=0&id=704f30dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports